import { render } from "./MeshFlaps.vue?vue&type=template&id=4fdabdfb&scoped=true"
import script from "./MeshFlaps.vue?vue&type=script&lang=js"
export * from "./MeshFlaps.vue?vue&type=script&lang=js"

import "./MeshFlaps.vue?vue&type=style&index=0&id=4fdabdfb&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fdabdfb"]])

export default __exports__